module.exports = __webpack_public_path__ + "816f98fecfb2b2f063c477baae15b2e7.png";